export default "__VITE_ASSET__2809105b__"